import { render } from "./ContentImageGallery.vue?vue&type=template&id=bff1a27c"
import script from "./ContentImageGallery.vue?vue&type=script&lang=js"
export * from "./ContentImageGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__